import { Box } from '@spark-web/box';
import { Container } from '@spark-web/container';
import { Spinner } from '@spark-web/spinner';
import { Stack } from '@spark-web/stack';
import { Text } from '@spark-web/text';

export function Loader() {
  return (
    <Container size="small">
      <Stack gap="xxlarge" padding="xxlarge">
        <Box flex={1} paddingY="xlarge" display="flex" alignItems="center" justifyContent="center">
          <Stack gap="large" padding="xxlarge" align="center">
            <Spinner size="xsmall" />
            <Text>Fetching details</Text>
          </Stack>
        </Box>
      </Stack>
    </Container>
  );
}
